import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarker } from '@fortawesome/free-solid-svg-icons';
import OutsideClick from '../../common/OutsideClick';
import useSearchHooks from '../../../store/hotel/search-hooks';

export default function LocationSelection() {
  const [showSearch, setShowSearch] = useState(false);
  const [locationList, setLocationList] = useState([]);
  const timerRef = useRef(null);
  const { setSearchParameters, search } = useSearchHooks();
  const { cityName } = search;
  const searchQuery = (value) => {
    setSearchParameters({ cityName: value });
    clearTimeout(timerRef.current);
    // set timeout to 500ms
    timerRef.current = setTimeout(() => {
      const url = `${process.env.API_URL}/hotel/location/?search=${value}`;
      const fetchData = async () => {
        try {
          const response = await fetch(url, { credentials: 'include' });
          const json = await response.json();
          setLocationList(json);

          setShowSearch(true);
        } catch (error) {
          console.log('error', error);
        }
      };
      fetchData();
    }, 300);
  };

  return (
    <div className="rs_form_row rs_autosuggest_row rs_1365_100 col-md-4 col-sm-12">
      <FontAwesomeIcon icon={faMapMarker} className="fa-location-icon" />
      <p className={cityName ? 'hide-placeholder d-block' : 'hide-placeholder '}>Where</p>
      <input
        name="query"
        className={cityName ? 'rs_autosuggest_act rs_autosuggest' : 'rs_autosuggest'}
        type="text"
        title="Enter a Destination"
        autoComplete="off"
        onChange={(e) => searchQuery(e.target.value)}
        value={cityName}
        onFocus={(event) => event.target.select()}
        placeholder="Where"
      />
      <OutsideClick click={setShowSearch} listener={showSearch}>
        <div className="rs_suggest" style={{ display: showSearch ? 'block' : 'none' }}>
          <h3>Location</h3>
          <ul className="p-0">
            {locationList.map((item) => (
              <li
                key={item.title}
                onClick={() => {
                  setSearchParameters({ cityName: item.title, latitude: item.latitude, longitude: item.longitude });
                  setShowSearch(false);
                }}
              >
                <FontAwesomeIcon icon={faMapMarker} className="select-color me-3" size="2x" />
                <p className="m-0">{item.title}</p>
              </li>
            ))}
          </ul>
        </div>
      </OutsideClick>
    </div>
  );
}
